/**
 * Хелпер для работы с сообщениями
 */
import EventApi from "../api/EventsApi";

export default class MessageHelper
{
    private static readonly EVENT_SEND_MESSAGE: string = 'sendMessage';
    private static readonly EVENT_DISABLE_PARSE_MESSAGES = 'disableParseMessages';
    public static readonly TYPE_CHANGE_CARDS: string = 'changeCards';
    public static readonly TYPE_CHANGE_STACKS: string = 'changeStacks';
    public static readonly TYPE_CHANGE_GAME_FIELD: string = 'changeGameField';
    public static readonly TYPE_PLAY_SOUND: string = 'playSound';
    public static readonly TYPE_CLOSE_NOTIFICATION: string = 'closeNotification';
    public static readonly TYPE_GET_CONTENT_PACK_TASKS: string = 'getContentPackTasks';
    public static readonly TYPE_CHANGE_PLAYER_NAME: string = 'changePlayerName';
    public static readonly TYPE_CHANGE_PLAYER_ICON: string = 'changePlayerIcon';
    public static readonly TYPE_CHANGE_PLAYER_POINTS: string = 'changePlayerPoints';
    public static readonly TYPE_CUSTOM_BUTTON: string = 'customButton';
    public static readonly TYPE_COUNT_VOTE: string = 'countVote';
    public static readonly TYPE_LOADER_FINISHED: string = 'loaderFinished';
    public static readonly TYPE_PLAYER_LOADER_FINISHED: string = 'playerLoaderFinished';
    public static readonly TYPE_FINISH_INTRO: string = 'introFinished';
    public static readonly TYPE_GET_STATE: string = 'getState';
    public static readonly TYPE_PLAYER_CONNECTED: string = 'playerConnected';
    public static readonly TYPE_TOGGLE_HAND: string = 'switchPlayerHand';
    public static readonly TYPE_PLAYER_REJECTED_GAME: string = 'playerRejectedGame';
    public static readonly TYPE_PLAYER_ACCEPTED_GAME: string = 'playerAcceptedGame';

    public static readonly TYPE_DELETE_CARDS = 1;
    public static readonly TYPE_FLIP_CARDS = 2;
    public static readonly TYPE_MOVE_CARD_TO_PLAYER = 3;
    public static readonly TYPE_MOVE_CARD_TO_TABLE_FROM_HAND = 4;
    public static readonly TYPE_ADD_CARD = 5;
    public static readonly TYPE_MOVE_CARD_ON_TABLE = 6;
    public static readonly TYPE_CHANGE_HAND_ITEMS_INDEX = 7;
    public static readonly TYPE_CHANGE_HAND_ITEMS_SORT = 8;
    public static readonly TYPE_CHANGE_CARD_BACKFACE = 9;
    public static readonly TYPE_CHANGE_META_DATA = 10;
    public static readonly TYPE_MOVE_SOLO_CARD_TO_STACK = 11;
    public static readonly TYPE_CHANGE_ON_TABLE_STATUS = 12;
    public static readonly TYPE_PAINT_CARD = 13;
    public static readonly TYPE_CHANGE_ETERNITY_STATUS = 14;
    public static readonly TYPE_CLEAR_CARD = 15;

    public static readonly TYPE_FLIP_STACKS = 1;
    public static readonly TYPE_DELETE_STACKS = 2;
    public static readonly TYPE_MOVE_TO_PLAYER = 3;
    public static readonly TYPE_MOVE_ON_TABLE = 4;
    public static readonly TYPE_ADD_STACKS = 5;
    public static readonly TYPE_SHUFFLE_STACKS = 6;
    public static readonly TYPE_LOCK_STACKS = 7;
    public static readonly TYPE_DEAL_STACK = 8;
    public static readonly TYPE_MOVE_N_TO_PLAYER = 9;
    public static TYPE_CREATE_RANDOM_ELEMENT = 11;
    public static TYPE_MERGE_STACKS = 12;
    public static TYPE_HIDE_STACKS = 13;
    public static TYPE_UNLOCK_STACKS = 14;
    public static TYPE_CHANGE_STACK_TITLE = 15;
    public static readonly TYPE_DISABLE_CARD_BY_ANOTHER_USAGE = 16;
    public static readonly TYPE_ENABLE_CARD_BY_ANOTHER_USAGE = 17;
    public static readonly TYPE_ROTATE_STACK = 19;

    public static TYPE_CHANGE_FIELD_BACKGROUND = 1;
    public static TYPE_CHANGE_SCALE = 2;
    public static TYPE_REFRESH_TABLE = 3;
    public static TYPE_CHANGE_PATTERN = 4;
    public static TYPE_CHANGE_SHOW_LOGO_STATE = 5;


    /**
     * Отправить сообщение об изменении карт
     * @param type
     * @param data
     */
    public static sendChangeCardsMessage(type: number, data: {[key: string]: any}): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_CHANGE_CARDS,
            data: {
                type: type,
                data: data,
            }
        });
    }

    /**
     * Отправить сообщение об изменении стопок карт
     * @param type
     * @param data
     */
    public static sendChangeStacksMessage(type: number, data: {[key: string]: any}): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_CHANGE_STACKS,
            data: {
                type: type,
                data: data,
            }
        });
    }

    /**
     * Отправить сообщение об изменении игрового поля
     * @param type
     * @param data
     */
    public static sendChangeFieldMessage(type: number, data: {[key: string]: any}): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_CHANGE_GAME_FIELD,
            data: {
                type: type,
                data: data,
            }
        });
    }

    /**
     * Отправить сообщение
     * @param type
     * @param data
     */
    public static sendMessage(type: string, data: {[key: string]: any}): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: type,
            data: data
        });
    }

    /**
     * Отключение обработки сообщений
     */
    public static disableParseMessages(): void
    {
        this.triggerGameEvent(this.EVENT_DISABLE_PARSE_MESSAGES);
    }

    /**
     * Триггер события игры
     */
    private static triggerGameEvent(eventName: string, data?: any): void
    {
        EventApi.triggerEvent(eventName, data);
    }

    /**
     * Отправить сообщение об изменении игрового поля
     * @param soundId
     */
    public static sendPlaySoundMessage(soundId: string): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_PLAY_SOUND,
            data: {
                sound: soundId,
            }
        });
    }

    /**
     * Закрыть уведомление
     */
    public static closeNotificationMessage(): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_CLOSE_NOTIFICATION,
            data: {}
        });
    }

    /**
     * Отправить сообщение о получении заданий для пака
     */
    public static getContentPackTasksMessage(data?: any): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_GET_CONTENT_PACK_TASKS,
            data: data
        });
    }

    /**
     * Отправить сообщение на изменение имени игрока
     */
    public static changePlayerNameMessage(data?: any): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_CHANGE_PLAYER_NAME,
            data: data
        });
    }

    /**
     * Отправить сообщение на изменение иконки игрока
     */
    public static changePlayerIconMessage(data?: any): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_CHANGE_PLAYER_ICON,
            data: data
        });
    }

    /**
     * Отправить сообщение на изменение очков игрока
     */
    public static changePlayerPointsMessage(data?: any): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_CHANGE_PLAYER_POINTS,
            data: data
        });
    }

    /**
     * Отправить сообщение клика на кастомную кнопку
     */
    public static clickCustomButtonMessage(data?: any): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_CUSTOM_BUTTON,
            data: data
        });
    }

    /**
     * Отправить сообщение клика на кастомную кнопку
     */
    public static countVoteMessage(data?: any): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_COUNT_VOTE,
            data: data
        });
    }

    /**
     * Отправить сообщение клика на кастомную кнопку
     */
    public static loaderFinished(data?: any): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_LOADER_FINISHED,
            data: data
        });
    }

    /**
     * Отправить сообщение клика на кастомную кнопку
     */
    public static playerLoaderFinished(data?: any): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_PLAYER_LOADER_FINISHED,
            data: data
        });
    }

    /**
     * Закончить интро
     */
    public static finishIntro(data?: any): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_FINISH_INTRO,
            data: data
        });
    }

    /**
     * Закончить интро
     */
    public static getState(): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_GET_STATE,
            data: {}
        });
    }

    /**
     * Игрок подключился к конфе
     */
    public static playerConnected(): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_PLAYER_CONNECTED,
            data: {}
        });
    }

    /**
     * Изменить видимость руки
     */
    public static toggleHandVisibility(data: any): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_TOGGLE_HAND,
            data: data
        });
    }

    /**
     * Отказаться от запуска игры
     */
    public static rejectGameSuggestion(data: any): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_PLAYER_REJECTED_GAME,
            data: data
        });
    }

    /**
     * Согласиться с запуском игры
     */
    public static acceptGameSuggestion(data: any): void
    {
        this.triggerGameEvent(this.EVENT_SEND_MESSAGE, {
            type: this.TYPE_PLAYER_ACCEPTED_GAME,
            data: data
        });
    }
}
